<div [ngClass]="state=='open' ? 'main_content_open' : 'main_content'">
    <p-scrollPanel [style]="{width: '100%', height: '95vh','margin-top':'7px','padding-bottom':'70px'}" #sc>
        <div class="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-3">
            <div class="page_title">
                Reports
            </div>
            <div>
                <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
            </div>
        </div>
        <div class="p-mb-5">
            <p-card>
                <div class="p-mb-3 toolbar">
                    <div class="p-grid p-ai-center">
                        <div class="p-col p-md-3 p-lg-3 p-fluid" style="padding: 0.5rem !important;">
                            <p-dropdown [options]="reports" [(ngModel)]="selectedReport" optionLabel="name"
                                optionValue="value" placeholder="Select Report"
                                (onChange)="onFilterValueChange($event)">
                            </p-dropdown>
                        </div>
                        <div *ngIf="showDateLayout" class="p-col p-md-3 p-lg-3 p-fluid"
                            style="padding: 0.5rem !important;">
                            <p-calendar [(ngModel)]="startDate" name="startDate" [showIcon]="true"
                                [readonlyInput]="false" placeholder="Enter Start Date"
                                (onClose)="onDateChange($event,'add_appointment')">
                            </p-calendar>
                        </div>
                        <div *ngIf="showDateLayout" class="p-col p-md-3 p-lg-3 p-fluid"
                            style="padding: 0.5rem !important;">
                            <p-calendar [(ngModel)]="endDate" name="endDate" [showIcon]="true" [readonlyInput]="false"
                                placeholder="Enter End Date" (onClose)="onDateChange($event,'add_appointment')">
                            </p-calendar>
                        </div>
                        <div *ngIf="showDateLayout" class="p-col p-md-3 p-lg-3 p-jc-end d-flex d-lg-flex d-xl-flex"
                            style="padding: 0.5rem !important;">
                            <button pButton pRipple type="button" label="Generate"
                                class="p-button-sm p-button-raised custom_add_btn" style="font-size: 12px;"
                                (click)="generateReport()"></button>
                        </div>

                        <div *ngIf="showNonDateLayout" class="p-col p-md-9 p-lg-9 p-jc-end d-flex d-lg-flex d-xl-flex"
                            style="padding: 0.5rem !important;">
                            <button pButton pRipple type="button" label="Generate"
                                class="p-button-sm p-button-raised custom_add_btn" style="font-size: 12px;"
                                (click)="generateReport()"></button>
                        </div>

                        <div *ngIf="showBusinessTypeLayout" class="p-col p-md-3 p-lg-3 p-fluid"
                            style="padding: 0.5rem !important;">
                            <p-dropdown [options]="businessTypes" [(ngModel)]="selectedBusinessType" optionLabel="name"
                                optionValue="value" placeholder="Select Business Type">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
                <div *ngIf="currentPosition!=''" class="container-fluid container-fullw bg-white"
                    style="padding:0 30px;">
                    <div *ngIf="currentPosition=='payment_history'">
                        <div class="row p-jc-center">
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalBusinesses}} <span style="font-size: 14px;">Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            <span style="font-size: 14px;">$</span> {{totalAmount}}
                                        </h4>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPosition=='client_engagement'">
                        <div class="row">
                            <div class="col-sm-3" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalSmsSent}} <span style="font-size: 14px;">SMS Sent</span></h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-3" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalBusinesses}} <span style="font-size: 14px;">Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-3" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalSmsReceived}} <span style="font-size: 14px;">SMS
                                                Received</span></h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-3" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalAppointments}} <span style="font-size: 14px;">Appointments</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPosition=='message_usage'">
                        <div class="row">
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalBusinesses}} <span style="font-size: 14px;">Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalNoOfCreditsAvailable}} <span style="font-size: 14px;">Credits
                                                Available</span></h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalNoOfCreditsUsed}} <span style="font-size: 14px;">Credits
                                                Used</span></h4>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPosition=='business_client'">
                        <div class="row">
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalBusinesses}} <span style="font-size: 14px;">Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalInactiveBusinesses}} <span style="font-size: 14px;">Inactive
                                                Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalActiveBusinesses}} <span style="font-size: 14px;">Active
                                                Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPosition=='business_type'">
                        <div class="row p-jc-center">
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            {{totalBusinesses}} <span style="font-size: 14px;">Businesses</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div class="col-sm-4" style="padding: 0.5rem !important;">
                                <div class="panel panel-white no-radius">
                                    <div class="panel-heading border-light">
                                        <h4 class="panel-title text-center" style="font-size: 18px;">
                                            <span style="font-size: 14px;">$</span> {{totalAnnualRevenue}} <span
                                                style="font-size: 14px;">Total Annual Revenue</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div *ngIf="currentPosition!=''" class="p-d-flex p-jc-end p-mb-2">
                    <button pButton pRipple type="button"
                        [label]="isExporting ? 'Exporting...' : 'Export Excel'"
                        [icon]="isExporting ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'"
                        class="p-button-sm p-button-raised p-button-success" style="font-size: 12px;"
                        [disabled]="isExporting || totalCount===0"
                        (click)="exportToExcel()"></button>
                </div>
                <p-table *ngIf="currentPosition!=''" #dt1 [columns]="cols" [value]="paymentReportList"
                    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped " [autoLayout]='false'
                    [responsive]='true' [rowHover]="true">
                    <ng-template pTemplate="header" let-columns>
                        <tr style="font-size: small;">
                            <th *ngFor="let col of columns" [ngClass]="{'sortable-header': col.sortable}"
                                [style.width]="col.width" (click)="onSortColumn(col)">
                                {{col.header}}
                                <i *ngIf="col.sortable" class="pi"
                                    [ngClass]="sortField == col.field ? (sortDirection == 'ASC' ? 'pi-sort-up active-sort' : 'pi-sort-down active-sort') : 'pi-sort'"></i>
                            </th>
                            <!-- <th>
                                        Action
                                    </th> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-report let-columns="columns">
                        <tr style="font-size: smaller;" [ngClass]="getExpiryRowClass(report)">
                            <td *ngFor="let col of columns" [style.width]="col.width">
                                <span class="p-column-title">{{col.header}}</span>
                                {{report[col.field]}}
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="columns.length+2">
                                <div *ngIf="isLoading" class="alignCenter">
                                    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                                    </p-progressSpinner>
                                </div>
                                <p-messages *ngIf="reportsList?.length == 0 && !isLoading" key="errMsg"
                                    class="alignCenter">
                                    <ng-template pTemplate>
                                        <i class="pi pi-copy" style="font-size: 2rem"></i>
                                        <div class="p-ml-2">NO DATA FOUND</div>
                                    </ng-template>
                                </p-messages>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-paginator #p [rows]="pageSize" [totalRecords]="totalCount" (onPageChange)="paginate($event)">
                </p-paginator>
            </p-card>
        </div>
    </p-scrollPanel>
</div>